var React = require('react');

function Cart (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M6.67647 0H0V3H4.48437L8.34228 22.0164H8.36012V22.5H26.4737V22.1278L29.5296 7.63643L30 6H7.87969L7.08499 2.08278L6.67647 0ZM26.4555 9H8.48831L10.6185 19.5H24.2413L26.4555 9Z","key":0}),React.createElement("path",{"d":"M12.5401 30C14.0792 30 15.3268 28.6569 15.3268 27C15.3268 25.3431 14.0792 24 12.5401 24C11.0011 24 9.75342 25.3431 9.75342 27C9.75342 28.6569 11.0011 30 12.5401 30Z","key":1}),React.createElement("path",{"d":"M25.0802 27C25.0802 28.6569 23.8326 30 22.2935 30C20.7544 30 19.5068 28.6569 19.5068 27C19.5068 25.3431 20.7544 24 22.2935 24C23.8326 24 25.0802 25.3431 25.0802 27Z","key":2})]);
}

Cart.defaultProps = {"width":"30","height":"30","viewBox":"0 0 30 30","fill":"#505050"};

module.exports = Cart;

Cart.default = Cart;
